import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { timStore } from "@/hooks";
import { PanelCard, Typography, Icon } from "@/components/common";


/**
 * Displays attributes of the selected artifact level.
 */
const __default__ = {
  name: "ArtifactLevelContent",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifactLevel = computed(() => timStore.selectedArtifactLevel);
const name = computed(() => artifactLevel.value?.name || "");
const artifactCount = computed(() => artifactLevel.value?.count || 0);

const iconId = computed(() => timStore.getTypeIcon(name.value));
const iconColor = computed(() => timStore.getTypeColor(name.value));

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_unref(PanelCard), { borderless: "" }, {
    title: _withCtx(() => [
      _createVNode(_unref(Typography), {
        ellipsis: "",
        variant: "subtitle",
        el: "h1",
        value: name.value,
        "data-cy": "text-selected-name"
      }, null, 8, ["value"]),
      _createVNode(_component_q_tooltip, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(name.value), 1)
        ]),
        _: 1
      })
    ]),
    "title-actions": _withCtx(() => [
      _createVNode(_unref(Icon), {
        id: iconId.value,
        size: "md",
        color: iconColor.value
      }, null, 8, ["id", "color"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Typography), {
        variant: "caption",
        value: "Artifacts"
      }),
      _createVNode(_unref(Typography), {
        el: "p",
        value: artifactCount.value
      }, null, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})